module.exports = __webpack_public_path__ + "static/media/26UNRWA24.efd1f14d.jpg";